import { GetSourcedCandidatesByCandidateBatchDocument } from 'generated-graphql/graphql';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';

type FetchSourcedCandidatesParams = {
  client: ApolloClient<NormalizedCacheObject>;
  candidateBatchId: string;
  nextToken?: string | null;
  acc?: SourcedCandidateQueryItem[];
};

const fetchSourcedCandidates = async ({
  client,
  candidateBatchId,
  nextToken = null
}: Omit<FetchSourcedCandidatesParams, 'acc'>) => {
  const { data } = await client.query({
    query: GetSourcedCandidatesByCandidateBatchDocument,
    variables: {
      candidateBatchId,
      limit: 100,
      nextToken
    }
  });

  const items = data?.getSourcedCandidatesByCandidateBatch?.items;
  const newNextToken = data?.getSourcedCandidatesByCandidateBatch?.nextToken;

  return {
    items,
    nextToken: newNextToken
  };
};

export const fetchAllSourcedCandidates = async ({
  client,
  candidateBatchId,
  nextToken = null,
  acc = []
}: FetchSourcedCandidatesParams): Promise<SourcedCandidateQueryItem[]> => {
  const { items, nextToken: newNextToken } = await fetchSourcedCandidates({
    client,
    candidateBatchId,
    nextToken
  });

  const newItems = items?.filter(
    (item) => item !== null
  ) as SourcedCandidateQueryItem[];

  const newAcc = [...acc, ...newItems];

  if (newNextToken) {
    const response = await fetchAllSourcedCandidates({
      client,
      candidateBatchId,
      nextToken: newNextToken,
      acc: newAcc
    });
    return response;
  }

  return newAcc;
};
